import React from "react";
import { useTranslation } from "react-i18next";

import { AppTextField } from "../../apps";
import { BankAccount } from "../../../types/models/Member";

interface Props {
  disabled: boolean;
  bank?: BankAccount;
}

const BankForm: React.FC<Props> = ({ disabled, bank }) => {
  const { t } = useTranslation();

  interface HandlePasteEvent extends React.ClipboardEvent<HTMLInputElement> {}

  const handlePaste = (event: HandlePasteEvent): void => {
    event.preventDefault();
  };

  return (
    <>
      <AppTextField
        placeholder={disabled ? bank?.accountName : t("accountName")}
        name="accountName"
        label={t("accountName")}
        disabled={disabled}
        onPaste={handlePaste}
      />
      <AppTextField
        placeholder={disabled ? bank?.accountNo : t("accountNo")}
        name="accountNo"
        label={t("accountNo")}
        disabled={disabled}
        onPaste={handlePaste}
      />
      <AppTextField
        placeholder={disabled ? bank?.bankName : t("bankName")}
        name="bankName"
        label={t("bankName")}
        disabled={disabled}
        onPaste={handlePaste}
      />
      <AppTextField
        placeholder={disabled ? bank?.name : t("name")}
        name="name"
        label={t("name")}
        disabled={disabled}
        onPaste={handlePaste}
      />
      <AppTextField
        placeholder={disabled ? bank?.lastname : t("lastname")}
        name="lastname"
        label={t("lastname")}
        disabled={disabled}
        onPaste={handlePaste}
      />
    </>
  );
};

export default BankForm;
